<template>
  <div id="main" ref="main">
  <Instruction></Instruction>

    <div class="container letters" v-for="(item, listno) in items" :key="listno">
      <span  v-for="(obj, index) in item" :key="index">
        <input
            v-model="items[listno][index].value"
            :disabled="obj.disabled"
            :data-row="listno"
            :data-col="index"
            :id="'input_' + listno + '_' + index"
            :class="'m-1 input_' + obj.classSuffix"
            @input="lettersInput"
            @focus="lettersFocus"
            @keydown="keyupInput"
            autocomplete="off"
        />
      </span>
    </div>
    <div>{{debug}}</div>
    <h2>{{ $t('main.norwegian-letters') }}:</h2>
    <div class="container align-content-center">
      <button class="btn btn-primary btn-letter" @click="keyboardClick">Ø</button>
      <button class="btn btn-primary btn-letter" @click="keyboardClick">Å</button>
      <button class="btn btn-primary btn-letter" @click="keyboardClick">Æ</button>
    </div>
    <h2>{{ $t('main.helplines') }}:</h2>
    <div class="container">
      <div class="row justify-content-md-center">
        <div class="col-6" style="text-align: center;">
          <i :class="'bi bi-translate ' + (translationShow?'biused':'')" @click="showTranslation"></i><br/>
          <span v-if="!translationShow" >{{ $t('main.show-translation') }}</span>
          <span v-if="translationShow" class="translation" >{{ $t('main.translation2') }}: {{finalTranslation}}</span>
        </div>
        <div  class="col-6" style="text-align: center;">
          <i :class="'bi bi-info-square ' + (letterShow?'biused':'')" @click="showLetter"></i><br/>
          <span v-if="!letterShow" >{{ $t('main.show-letter') }}</span>
          <span v-if="letterShow" class="translation" >{{ $t('main.word-pattern') }}: {{wordPattern}}</span>
        </div>
      </div>
    </div>
  </div>
  <Modal :description="finalDesc" :fullform="finalFullform" :example="finalExample" :variations="finalVariations" :translation="finalTranslation" :word="finalWord" ref="modal"></Modal>
  <div class="row" v-if="false" >
    <div class="col-md-12">
      <div class="card col-md-12" style="">
        <div class="card-body">
          <h5 class="card-title">{{ $t('main.congratulations') }}: {{finalWord}}!</h5>
          <p class="card-text">{{ $t('main.translation') }}: {{finalTranslation}}. {{finalDesc}}</p>
          <a :href="$t('common.coursesLink')" target="_blank" class="btn btn-primary">{{ $t('common.coursesRead') }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { reactive } from "vue";
import axios from "axios";
import confetti from "canvas-confetti";
import 'bootstrap/dist/css/bootstrap.min.css'
import "bootstrap-icons/font/bootstrap-icons.css";
import Modal from "@/components/Modal";
import Instruction from "@/components/Instruction";
import {scroller} from 'vue-scrollto/src/scrollTo'
import { hide, show } from 'uspin'
export default {
  name: "HelloWorld",
  components: {Modal,Instruction},
  props: {
    wordCount: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {finalWord:"",
      finalTranslation:"",
      finalDesc:"",
      finalFullform:"",
      finalVariations:"",
      finalExample:"",
      translationShow:false,
      letterShow:false,
      wordPattern:"",
      debug:"",
      nowAjax:false,
      shownLetter:"",
      shownLetterIndex:-1,

    };
  },
  mounted() {
    show(this.$refs.main);
    // Generate today's date in YYYYMMDD format
    const today = new Date();
    const dateStr = today.getFullYear() +
                    String(today.getMonth() + 1).padStart(2, '0') +
                    String(today.getDate()).padStart(2, '0');

    axios
        .get(`https://media.akademianorweskiego.pl/ord/${dateStr}.json`)
        .then((res) => {

          console.log(res);
            this.finalWord = res.data.finalWord;
            this.finalDesc = res.data.finalDesc;
            this.finalFullform = res.data.finalFullform;
            this.finalVariations = res.data.finalVariations;
            this.finalExample = res.data.finalExample;
            this.finalTranslation = res.data.finalTranslation;
            this.length = this.finalWord.length;
            this.lastRow = -1;
            this.addNewEmptyRow();hide(this.$refs.main);
          document.getElementById("input_0_0").focus();

          console.log(this.items);
            return;
        })
        .catch((err) => {
          console.log(err.response);
        });

  },
  setup() {
    let items = [];
    items[0] = [];
    const myScroller = scroller();

    return {
      items: reactive(items),
      lastRow:0,
      end:false,
      scroller: myScroller,
    };
  },
  methods: {
    lettersInput(event) {

      if (!event) return;
      let row = parseInt(event.target.getAttribute("data-row"));
      let col = parseInt(event.target.getAttribute("data-col"));
      event.target.blur();
      if (event.target.value.length > 1) {
        this.items[row][col].value = this.items[row][col].value.substring(1,2);
      }


      if (!this.checkWord(row)) this.gotoNextInput(row, col);
    },
    keyboardClick(event){
      let letter = event.target.innerHTML;
      let index =0;
      for(let i=0;i<this.length;i++){
        if(this.items[this.lastRow][i].value ===""){
          this.items[this.lastRow][i].value = letter;
          index=i;
          break;
        }
      }
      if (!this.checkWord(this.lastRow)) this.gotoNextInput(this.lastRow, index);
    },
    setCharAt(str,index,chr) {
      if(index > str.length-1) return str;
      return str.substring(0,index) + chr + str.substring(index+1);
    },
    determinePattern(){
      let letters = "";
      let symbol = '❓';
      let blanks = 0;
      for(let i=0;i<this.length;i++){
        letters += symbol;
      }
      for(let row=0;row<this.items.length;row++){
        for(let col=0;col<this.items[row].length;col++){
          if(this.items[row][col].classSuffix=="ok"){
            letters=this.setCharAt(letters,col,  this.items[row][col].value);
          }
        }
      }
      for(let i=0;i<this.length;i++){
        if(letters.charAt(i) === symbol){
          blanks++;
        }
      }
      if(blanks>0){
        let rand = this.getRandomInt(0,blanks-1);
        let index = 0;
        for(let i=0;i<this.length;i++) {
          if(letters.charAt(i) === symbol){
            if(index==rand){
              letters=this.setCharAt(letters,i, this.finalWord.charAt(i));
              this.shownLetterIndex = i;
              this.shownLetter = this.finalWord.charAt(i);
            }
            index++;
          }
        }
      }

      this.wordPattern = letters.toUpperCase();
    },
    showTranslation(event){
      this.translationShow = true;
    },
    getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    showLetter(event){
      if(!this.letterShow) {
        this.letterShow = true;
        this.determinePattern();
      }
      this.items[this.lastRow][this.shownLetterIndex].value = this.shownLetter;
      this.items[this.lastRow][this.shownLetterIndex].classSuffix = "ok";
    },
    keyupInput(event){
      if(event.keyCode !=8) return;
      let row = parseInt(event.target.getAttribute("data-row"));
      let col = parseInt(event.target.getAttribute("data-col"));
      if(col<1) return;
      document.getElementById("input_"+row+"_"+(col-1)).focus();
      this.items[row][col-1].value="";
    },
    addNewEmptyRow(){
      this.lastRow++;
      this.items[this.lastRow] = [];
      for (let i = 0; i < this.length; i++) {
        this.items[this.lastRow][i] = {
          value: "",
          disabled: false,
          classSuffix: ""
        };
      }
      this.focusLastRow()
      this.scroller("#input_"+this.lastRow+"_0");

    },
    focusLastRow(){
      setTimeout(function(a){
        document.getElementById("input_"+a.lastRow+"_0").focus();
      },100,this);
    },
    resetLastRow(){
      for (let i = 0; i < this.length; i++) {
        this.items[this.lastRow][i] = {
          value: "",
          disabled: false,
          classSuffix: ""
        };
      }
      this.focusLastRow()
    },
    gotoNextInput(row, col) {
      if (col >= this.length - 1) return;
      let id = "input_" + row + "_" + (col + 1);
      console.log(id);
      let el = document.getElementById(id);
      el.focus();
    },
    checkWord(row) {
      let word = this.getWord(row);


      if (word.length == this.length) {
        this.disableRow(row);
        this.checkWordAjax(row);
        return true;
      }
      return false;
    },
    getWord(row) {
      let word = "";
      for (let i = 0; i < this.length; i++) {
        word += this.items[row][i].value;
      }
      return word;
    },
    checkWordAjax(row) {
      let word = this.getWord(row).toLowerCase();
      let target = this.finalWord.toLowerCase();

      if(this.nowAjax)
        return;
      this.nowAjax = true;

      // If it's the correct word, skip dictionary check and validate directly
      if(word === target) {
        this.validateWord(row, word, target);
        return;
      }

      // Check if word exists in dictionary
      axios.get(`https://api1.puffli.no/ord/check?word=${word}`)
        .then((res) => {
          if(res.data.data.exists) {
            // Word exists, proceed with validation
            this.validateWord(row, word, target);
          } else {
            // Word doesn't exist, mark as invalid
            setTimeout(() => {
              this.nowAjax = false;
              for(let j = 0; j < this.length; j++){
                this.items[this.lastRow][j].classSuffix = "notexist";
              }
              // Reset the row after a short delay
              setTimeout(() => {
                this.resetLastRow();
              }, 800);
            }, 300);
          }
        })
        .catch((err) => {
          console.log(err);
          // On error, allow the word anyway
          this.validateWord(row, word, target);
        });
    },
    validateWord(row, word, target) {
      // Client-side validation
      let result = [];
      let targetLetters = target.split('');
      let wordLetters = word.split('');
      let used = new Array(this.length).fill(false);

      // First pass: mark correct positions
      for(let i = 0; i < this.length; i++) {
        if(wordLetters[i] === targetLetters[i]) {
          result[i] = 'ok';
          used[i] = true;
        }
      }

      // Second pass: mark existing letters in wrong positions
      for(let i = 0; i < this.length; i++) {
        if(result[i] === 'ok') continue;

        let found = false;
        for(let j = 0; j < this.length; j++) {
          if(!used[j] && wordLetters[i] === targetLetters[j]) {
            result[i] = 'exist';
            used[j] = true;
            found = true;
            break;
          }
        }

        if(!found) {
          result[i] = 'wrong';
        }
      }

      // Apply results
      setTimeout(() => {
        this.nowAjax = false;
        let allok = true;
        for(let j = 0; j < this.length; j++){
          this.items[this.lastRow][j].classSuffix = result[j];
          console.log(result[j]);
          if(result[j] !== "ok")
            allok = false;
        }

        if(allok){
          this.finish();
          return;
        }

        this.addNewEmptyRow();
        console.log(this.items);
      }, 300);
    },
    finish(){
      this.$refs.modal.show();
      this.end = true;
      const duration = 15 * 1000;
      const animationEnd = Date.now() + duration;
      const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };

      function randomInRange(min, max) {
        return Math.random() * (max - min) + min;
      }

      let interval = setInterval(function() {
        let timeLeft = animationEnd - Date.now();

        if (timeLeft <= 0) {
          return clearInterval(interval);
        }

        let particleCount = 50 * (timeLeft / duration);
        // since particles fall down, start a bit higher than random
        confetti(Object.assign({}, defaults, { particleCount, origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 } }));
        confetti(Object.assign({}, defaults, { particleCount, origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 } }));
      }, 250);
    },
    lettersFocus(event) {
      let row = parseInt(event.target.getAttribute("data-row"));
      let col = parseInt(event.target.getAttribute("data-col"));
      this.items[row][col].value="";
      //event.target.value = "";
    },
    disableRow(row) {
      for (let i = 0; i < this.length; i++) {
        this.items[row][i].disabled = true;
      }
      console.log(this.items);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.letters input {
  width: 56px;
  height: 82px;
  font-size: 48pt;
  padding:0px;
  text-align: center;
  text-transform: uppercase;
}
@media only screen and (max-width: 560px) {
  .letters input {
    width: 50px;
    height: 60px;
    font-size: 35pt;
    padding:0px;
  }
}
@media only screen and (max-width: 440px) {
  .letters input {
    width: 33px;
    height: 45px;
    font-size: 22pt;
    padding:0px;
  }
}
.container{
  max-width:560px;
}
.letters{
  margin-bottom:10px;
}
.letters input.input_wrong{
  background-color: grey;
}
.letters input.input_ok{
  background-color: lightgreen;
}
.letters input.input_exist{
  background-color: orange;
}
.letters input.input_notexist{
  background-color: red;
}
i{
  width:128px;
  height:128px;
  font-size:6rem;
  color:blue;
  margin-right:10px;
}
.biused{
  color:grey;
}
.translation{
  font-weight:bold;
  font-size:150%;
}
.btn-letter{
  width:50px;
  height:50px;
  padding:0;
  font-size:24pt;
  margin-bottom:15px;
  line-height:1.2;
  margin-right:5px;
}
.container{
  line-height:1.2!important;
}
</style>
